<template>
  <div class="h-popup"
       ref="popup"
       v-show="visible"
       @click.self="closePopup">
    <div class="h-popup-container h-outer-border h-bg"
         :class="[`around-${borderIndex}`, borderIndex === 6 ? 'blue-1' : 'brown-1']">
      <slot></slot>
    </div>
  </div>
</template>

<style lang="stylus" scoped>
  .h-popup
    position fixed
    left 0
    top 0
    z-index 1000
    width 100%
    height 100%
    background-color rgba(0, 0, 0, .5)

  .h-popup .h-popup-container
    position absolute
    left 50%
    top 50%
    padding 15px 15px 20px
    transform translate(-50%, -50%)
    &:before
      border-width 35px
      z-index 0 !important

</style>

<script type="text/babel">
  export default {
    data () {
      return {}
    },

    props: {
      visible: {
        type: Boolean,
        default: false
      },
      zIndex: {
        type: Number,
        default: 1000
      },
      closeOnClickModal: {
        type: Boolean,
        default: true
      },
      borderIndex: {
        type: Number,
        default: 3
      }
    },

    async mounted () {
      this.$refs.popup.style.zIndex = this.zIndex
    },

    methods: {
      closePopup () {
        if (this.closeOnClickModal) {
          this.$emit('update:visible', false)
        }
      }
    },

    components: {}
  }
</script>
